import { createSelector } from '@reduxjs/toolkit';
import { selectConfigFromBootstrap } from 'store/slice/bootstrap';
import { CmsValue, Language } from 'core/type/BootstrapConfig.types';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesContinueYourBookingCardClickEventActivitiesFieldsV2 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesContinueYourBookingCardClickEventActivitiesManifestV2 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { getPaxQueryParams } from 'core/utils/activityUrlGenerator';
import { ContinueYourBookingActivity } from 'component/page/home/ContinueYourBooking/ContinueYourBooking.types';
import { getDateInYmdFormat } from 'core-framework/util/datetime/date';

interface StateProps {
    cms: CmsValue;
    language: Language;
    isMockData: boolean;
    screenSize: ScreenSize;
}

export interface DispatchProps {
    onClickHandler: (activity: ContinueYourBookingActivity, index: number) => void;
}

export type ContinueYourBookingProps = StateProps & DispatchProps;

export const mapStateToProps = createSelector(selectConfigFromBootstrap, selectScreenSize, (config, screenSize): StateProps => {
    const { cms, language, isMockData } = config;
    return {
        cms,
        language,
        isMockData,
        screenSize,
    };
});

export const mapDispatchToProps = (): DispatchProps => ({
    onClickHandler: (activity: ContinueYourBookingActivity, index: number) => {
        const paxList = getPaxQueryParams(activity.pax);
        trackElementEvent<ActivitiesContinueYourBookingCardClickEventActivitiesFieldsV2>(
            ActivitiesContinueYourBookingCardClickEventActivitiesManifestV2.ids,
            {
                activity_id: activity.activityId,
                travel_date: getDateInYmdFormat(activity.travelDate),
                offer_id: activity.enrichedOfferId,
                offer_option_token: activity.offerOptionId,
                action_element_value: paxList,
            },
            { action_element_index: index + 1 },
        );
    },
});
